import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getDashboardApi } from "mock/dashboardDemoData";

const StaffDetailsChart = () => {

  const [staffDetails, setStaffDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const clientId = localStorage.getItem("client_id")

  useEffect(() => {
    let isMounted = true;
    
    const fetchData = async () => {
      try {
        const { error, result } = await getDashboardApi(`/client_user_details?client_id=${clientId}`);
        if (!error && isMounted) {
          console.log('Staff Details API Response:', result);
          // API returns {success, message, result}, so we need result.result
          setStaffDetails(result.result || []);
        }
      } catch (err) {
        console.error('Error fetching staff details:', err);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };
    
    if (clientId) {
      fetchData();
    } else {
      setIsLoading(false);
    }
    
    return () => {
      isMounted = false;
    };
  }, [clientId]);

  // Transform data: categories are states, series are staff types (stacked)
  const categories = ["VIC", "NSW", "QLD", "WA", "SA", "TAS", "ACT"];
  
  // Create a map of state names to abbreviations - include multiple variations
  const stateMap = {
    "Victoria": "VIC",
    "VIC": "VIC",
    "New South Wales": "NSW",
    "NSW": "NSW",
    "Queensland": "QLD",
    "QLD": "QLD",
    "Western Australia": "WA",
    "WA": "WA",
    "South Australia": "SA",
    "SA": "SA",
    "Tasmania": "TAS",
    "TAS": "TAS",
    "Australian Capital Territory": "ACT",
    "ACT": "ACT"
  };
  
  // Create a lookup object for easy access
  const stateDataMap = {};
  staffDetails.forEach(state => {
    const abbr = stateMap[state.state_name];
    if (abbr) {
      stateDataMap[abbr] = state;
    }
  });
  
  // Create series for each staff type (these will be stacked)
  const series = [
    {
      name: "Facility Staff",
      data: categories.map(abbr => stateDataMap[abbr]?.staff_count || 0)
    },
    {
      name: "Managers",
      data: categories.map(abbr => stateDataMap[abbr]?.manager_count || 0)
    },
    {
      name: "Support Staff",
      data: categories.map(abbr => stateDataMap[abbr]?.floater_staff_count || 0)
    }
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
      },
    },

    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: '11px',
        }
      }
    },

    yaxis: {
      title: {
        text: "Staff Count",
      },
    },

    colors: [
      "#1E76C9", // Staff
      "#F6549E", // Managers
      "#FF9500", // Floater Staff
    ],

    legend: {
      position: "top",
      fontSize: "11px",
    },

    tooltip: {
      y: {
        formatter: (val) => `${val} Staff`,
      },
    },

    dataLabels: {
      enabled: false,
    },
  };

  return (
    <div className="title-container">
      <div className="mb-3">Staff Details by State</div>

      {isLoading || staffDetails.length === 0 ? (
        <div style={{ 
          height: 220, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: '#666'
        }}>
          {isLoading ? 'Loading staff details...' : 'No staff data available'}
        </div>
      ) : (
        <Chart
          options={options}
          series={series}
          type="bar"
          height={220}
        />
      )}
    </div>
  );
};

export default StaffDetailsChart;
